import { useQuery } from '@tanstack/react-query'
import { sacrificeApi } from '../config/sacrifice-api'
import { useInstanceAuth } from '../contexts/InstanceAuthContext'

/**
 * Whether the connected, instance-signed-in wallet is an instance admin.
 * Returns false (and makes no request) when signed out.
 */
export const useInstanceAdmin = (): { isInstanceAdmin: boolean; isLoading: boolean } => {
  const { authData, isSignedIn } = useInstanceAuth()

  const { data, isLoading } = useQuery({
    queryKey: ['instanceAdmin', authData?.signature ?? null],
    queryFn: async ({ signal }) => {
      if (!authData) throw new Error('Not signed in')
      return await sacrificeApi.instance.whoami({
        request: { signature: authData.signature, inputs: { timestamp: authData.timestamp } },
        signal,
      })
    },
    enabled: isSignedIn && authData !== null,
    staleTime: 5 * 60 * 1000,
  })

  return { isInstanceAdmin: data?.isInstanceAdmin ?? false, isLoading: isSignedIn && isLoading }
}
